import { setAdvtState } from '../safeSetAdvtState.js';
import { QueryParam } from './QueryParam.js';
import { ShortPlacementId } from './ShortPlacementId.js';

let isDebugMode: boolean | undefined;
let debugPlacementFilter: string | null | undefined;

setAdvtState('toggleDebug', () => {
  const localStorageHasDebugFlag =
    window.localStorage.getItem(DebugMode.ENABLED_DEBUG_PARAM) === 'true';

  if (localStorageHasDebugFlag) {
    window.localStorage.removeItem(DebugMode.ENABLED_DEBUG_PARAM);
    window.localStorage.removeItem(DebugMode.ENABLED_DEBUG_PARAM_PLACEMENT_ID);
    debugPlacementFilter = null;

    return false;
  }

  window.localStorage.setItem(DebugMode.ENABLED_DEBUG_PARAM, 'true');

  console.log(
    '%cDebug mode enabled - refresh page to apply...',
    'font-size: x-large; color: green; font-weight: bold;'
  );

  return true;
});

export namespace DebugMode {
  export const ENABLED_DEBUG_PARAM = 'advt_debug';
  export const ENABLED_DEBUG_PARAM_PLACEMENT_ID = 'advt_debug_placement';

  export function isActive() {
    if (typeof window === 'undefined') return false; // Debug mode is only relevant in a browser environment

    isDebugMode ??=
      window.localStorage.getItem(ENABLED_DEBUG_PARAM) === 'true' ||
      QueryParam.has(ENABLED_DEBUG_PARAM);

    if (isDebugMode && !debugPlacementFilter) {
      const placementId =
        QueryParam.get(ENABLED_DEBUG_PARAM_PLACEMENT_ID) ||
        window.localStorage.getItem(ENABLED_DEBUG_PARAM_PLACEMENT_ID);

      if (placementId) {
        debugPlacementFilter = ShortPlacementId.from(placementId);
      }
    }

    return isDebugMode;
  }

  export function shouldSkipLogging(...args: Array<unknown>) {
    if (!isActive()) return true;
    if (!debugPlacementFilter) return false;

    for (const arg of args) {
      if (typeof arg !== 'string') continue;
      if (!arg.includes(debugPlacementFilter)) continue;

      return false;
    }

    return true;
  }
}
